// The one place the LMS bundle reads its Supabase endpoint and key. A bundle
// built without them (no `.env`, or the Sensitive Vercel vars pulled as "")
// cannot work: on 2026-11-02 a Nest dist with VITE_SUPABASE_URL="" reached
// production and every call went to the app's own host (405).
//
// vite.config.ts / vite.widget.config.ts refuse to build without these
// (src/config/buildEnvGuard.ts); this module is the runtime second line and
// keeps the client's original contract: throw at import when either is
// missing. Whitespace-only counts as missing; set values pass through as-is.

const MISSING =
  "Missing Supabase env vars: ensure VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY are set";
const HINT =
  "(this bundle was built without the Supabase env; Sensitive Vercel vars pull as empty strings, never ship a locally built dist)";

function present(value: unknown): value is string {
  return typeof value === "string" && value.trim() !== "";
}

const url: unknown = import.meta.env.VITE_SUPABASE_URL;
const key: unknown = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!present(url) || !present(key)) {
  throw new Error(`${MISSING} ${HINT}`);
}

export const SUPABASE_URL: string = url;
export const SUPABASE_PUBLISHABLE_KEY: string = key;
